import { useMemo } from 'react'
import { ColDef, ColGroupDef } from 'ag-grid-community'
import { useRowNumber } from '../../../../page-properties/bulksheet-properties/rowNumber'
import { dragAndDrop } from '../../../../page-properties/bulksheet-properties/dragAndDrop'
import { basicColumns } from './basicColumns'
import { aggregationColumns } from './aggregationColumns'
import { ganttColumnGroup } from './ganttColumn'
import { PROGRAM_MANAGEMENT_ROW_TYPE } from '../../programManagement'

export { basicColumns, aggregationColumns }

const programDragAndDrop: ColDef = {
  ...dragAndDrop,
  rowDrag: params => {
    const type = params.data?.type
    return (
      type !== PROGRAM_MANAGEMENT_ROW_TYPE.PROCESS &&
      type !== PROGRAM_MANAGEMENT_ROW_TYPE.WORKGROUP
    )
  },
}

export const useColumnDefs = (): (ColDef | ColGroupDef)[] => {
  const rowNumberCol = useRowNumber()

  const columnDefs = useMemo(
    () => [
      {
        field: 'uuid',
        hide: true,
        suppressColumnsToolPanel: true,
      },
      {
        colId: 'blank',
        hide: true,
        width: 35,
        suppressColumnsToolPanel: true,
      },
      rowNumberCol,
      programDragAndDrop,
      ...basicColumns,
      ...aggregationColumns,
      ganttColumnGroup,
    ],
    [rowNumberCol]
  )
  return columnDefs
}
